export const restoreAll = "jbb";
export default {restoreAll};